import { GovernmentRecord } from "../types";

export type HistoryKind = "liberal" | "fascist" | "neutral" | "win";

/** Plain-language description of one history entry. */
export function describeRecord(record: GovernmentRecord): {
  government: string;
  result: string;
  kind: HistoryKind;
} {
  const government =
    record.president && record.chancellor
      ? record.president + " + " + record.chancellor
      : "Election tracker";
  switch (record.outcome) {
    case "LIBERAL":
      return { government, result: "Liberal", kind: "liberal" };
    case "FASCIST":
      return { government, result: "Fascist", kind: "fascist" };
    case "REJECTED":
      return { government, result: "Rejected", kind: "neutral" };
    case "VETOED":
      return { government, result: "Vetoed", kind: "neutral" };
    case "CHAOS_LIBERAL":
      return { government, result: "Top card: Liberal", kind: "liberal" };
    case "CHAOS_FASCIST":
      return { government, result: "Top card: Fascist", kind: "fascist" };
    case "HITLER_ELECTED":
      return { government, result: "Hitler elected", kind: "win" };
    case "HITLER_EXECUTED":
      return {
        government: record.president + " executed " + record.chancellor,
        result: "Hitler executed",
        kind: "win",
      };
    case "IN_SESSION":
    default:
      return { government, result: "In session", kind: "neutral" };
  }
}

/** One sentence about the most recent government that has finished, for the game screen. */
export function lastGovernmentSentence(history: GovernmentRecord[] | undefined): string | undefined {
  if (!history) {
    return undefined;
  }
  for (let i = history.length - 1; i >= 0; i--) {
    const r = history[i];
    const pair = r.president + " and " + r.chancellor;
    switch (r.outcome) {
      case "LIBERAL":
        return pair + " enacted a Liberal policy.";
      case "FASCIST":
        return pair + " enacted a Fascist policy.";
      case "REJECTED":
        return "The vote on " + pair + " failed.";
      case "VETOED":
        return pair + " vetoed their agenda.";
      case "CHAOS_LIBERAL":
        return "Three failed governments: the top policy (Liberal) was enacted.";
      case "CHAOS_FASCIST":
        return "Three failed governments: the top policy (Fascist) was enacted.";
      default:
      // IN_SESSION and game-ending entries: keep looking back.
    }
  }
  return undefined;
}
